import FilterInput from "@/components/ui/table/Filter/FilterInput";
import { ReportColumn } from "@/types/evaluate";
import React from "react";
import { useModalRouter } from "../../modal-router-context";
import { ContextMenu } from "@/components/ui/ContextMenu";
import { useHeaderContextMenu } from "./hooks/useHeaderContextMenu";
import { ChevronDownIcon } from "@heroicons/react/outline";
import {
  ConfirmationModal,
  ConfirmationModalVariant,
} from "@/components/ConfirmationModal";
import { Cell } from "./Cell";

interface HeaderCellProps {
  column: ReportColumn;
  reportId: number;
  availableColumns: ReportColumn[];
  isEditable: boolean;
}

const HeaderCell: React.FC<HeaderCellProps> = (props) => {
  const { setIsOpen, setSelectedColumn } = useModalRouter();

  const handleOpenModal = () => {
    setSelectedColumn(props.column);
    setIsOpen(true);
  };

  const {
    contextMenuItems,
    isDeleteConfirmationOpen,
    setIsDeleteConfirmationOpen,
    handleConfirmDelete,
    handleCancelDelete,
    showFilterInput,
    setShowFilterInput,
  } = useHeaderContextMenu({
    column: props.column,
    reportId: props.reportId,
    availableColumns: props.availableColumns,
    isEditable: props.isEditable,
    onOpenModal: handleOpenModal,
  });

  return (
    <div className="group relative h-[72.5px] w-full select-none">
      <ContextMenu
        shouldOpenContextMenuByLeftClick
        contextMenuItems={contextMenuItems}
        data={props.column}
      >
        <div className="relative flex h-full w-full cursor-pointer items-center">
          <div className="flex h-full w-full items-center px-6">
            <Cell column={props.column} />
          </div>
          <ChevronDownIcon className="absolute right-2 h-5 w-5 text-gray-500 opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
        </div>
      </ContextMenu>
      {showFilterInput && (
        <FilterInput
          column={props.column}
          onClose={() => setShowFilterInput(false)}
        />
      )}
      <ConfirmationModal
        title="Delete Column"
        description={`Are you sure you want to delete the column "${props.column.name}"? This action cannot be undone.`}
        isOpen={isDeleteConfirmationOpen}
        setIsOpen={setIsDeleteConfirmationOpen}
        leaveButtonText="Cancel"
        saveButtonText="Delete"
        handleOnConfirm={handleConfirmDelete}
        handleLeave={handleCancelDelete}
        handleClose={handleCancelDelete}
        headerVariant={ConfirmationModalVariant.warning}
        saveButtonVariant="destructive"
        exitButtonVariant="secondary"
      />
    </div>
  );
};

export default HeaderCell;
